export const DATA = {
  "Skill level": "Beginner",
  "Time to complete": "Approx. 60 hours",
  Certificate: "Included",
  Prerequesties: "Python + Data Science Level - 1",
  description: "Deep Learning With Python",
  about:
    "Designed for learners eager to explore the world of data and AI, this course provides a solid foundation on data analysis, visualization, and core concepts of machine learning. Through hands-on projects, you'll gain skills needed to grow into real-world data scientist.",
  skills: [
    "Neural Networks",
    "Image Classification",
    "Natural Language Processing",
  ],
  reviews: {
    1: {
      name: "Jared McKinley",
      review:
        "This advanced Data Science course really pushed my skills. The instructor explained machine learning concepts clearly and guided us through practical model building. A very well-structured experience.",
    },
    2: {
      name: "Megha Kulkarni",
      review:
        "Level II was exactly what I needed after completing the basics. The real-world case studies and predictive modeling exercises were incredibly helpful.",
    },
    3: {
      name: "Thomas Riggs",
      review:
        "I loved how deeply the course covered machine learning algorithms. The step-by-step approach made even the harder topics like regularization easy to understand.",
    },
    4: {
      name: "Ariella Simmons",
      review:
        "The course was challenging in the best way. The instructor explained advanced concepts like feature engineering and model tuning beautifully.",
    },
    5: {
      name: "Hiro Tanaka",
      review:
        "Amazing experience! I finally understood how algorithms work under the hood. The coding exercises helped reinforce every concept.",
    },
    6: {
      name: "Chiara Lombardi",
      review:
        "This course takes learning to the next level. The blend of ML theory and hands-on tasks was perfect. I now feel more confident building complete models.",
    },
    7: {
      name: "Daniel Moretti",
      review:
        "Very detailed and practical. I especially enjoyed the sections on supervised and unsupervised learning. Excellent for serious learners.",
    },
    8: {
      name: "Sasha Kovalenko",
      review:
        "A wonderful upgrade from Level I. The instructor explained complex algorithms in simple terms and guided us through real applications.",
    },
    9: {
      name: "Emanuel Ortega",
      review:
        "This course offered the perfect balance of theory and implementation. I really enjoyed the deep dive into evaluation metrics and model performance.",
    },
    10: {
      name: "Lydia Pearson",
      review:
        "I appreciated the clarity and depth of explanation. Even difficult concepts like decision boundaries were broken down into easy steps.",
    },
    11: {
      name: "Ronan Cassidy",
      review:
        "A great advanced course. The assignments made sure we truly understood things, rather than just memorizing formulas.",
    },
    12: {
      name: "Fatemeh Jafari",
      review:
        "I learned so much about predictive analytics and model building. The examples were practical and well-designed.",
    },
    13: {
      name: "Calvin Rhodes",
      review:
        "Clear, practical, and very insightful. Level II truly strengthened my understanding of ML workflows and optimization methods.",
    },
    14: {
      name: "Noura Al-Saadi",
      review:
        "A fantastic deep dive into Data Science. The lessons on clustering and classification were my favorites.",
    },
    15: {
      name: "Declan Hughes",
      review:
        "The way advanced algorithms were explained was impressive. I finally understand how to tune models and prevent overfitting.",
    },
    16: {
      name: "Zarina Murodova",
      review:
        "The project-based approach kept me engaged throughout. I enjoyed building models that actually solved real problems.",
    },
    17: {
      name: "Pierce Warner",
      review:
        "An excellent continuation from Level I. The coverage of model validation and feature transformations was exceptional.",
    },
    18: {
      name: "Mariam Boswell",
      review:
        "I’m grateful for how approachable the instructor made advanced Data Science topics. I feel much more prepared for real-world data challenges.",
    },
    19: {
      name: "Jonas Nilsson",
      review:
        "The hands-on notebooks and exercises were extremely valuable. I now understand the nuances of selecting the right algorithm for a dataset.",
    },
    20: {
      name: "Tiffany Chau",
      review:
        "A very strong advanced course. The instructor gave real clarity to topics like gradient descent and hyperparameter tuning.",
    },
    21: {
      name: "Gareth Rowe",
      review:
        "I enjoyed the blend of math, coding, and intuition. This course built my confidence in building machine learning pipelines.",
    },
    22: {
      name: "Yeonwoo Park",
      review:
        "The examples were real enough to feel professional but still simple enough to understand. A great learning experience.",
    },
    23: {
      name: "Reina Delgado",
      review:
        "This course helped tie all the basics together into something practical. I loved building full ML models from scratch.",
    },
    24: {
      name: "Owen Sharpe",
      review:
        "Very insightful course! I now understand how to evaluate models properly and interpret the results with confidence.",
    },
    25: {
      name: "Hollie Barrett",
      review:
        "A rich, well-paced Level II program. It strengthened my analytical thinking and taught me how to handle complex data problems.",
    },
  },
  modules: {
    "Deep Learning Foundations": [
      "Neural Networks vs Traditional Machine Learning.",
      "Biological vs Artificial Neurons.",
      "Structure of a neural network.",
      "Understanding layers, weights, and parameters.",
      "Feedforward networks and dense layers.",
      "Activation Functions.",
    ],
    "Neural Network Training": [
      "Forward and backward propagation.",
      "Loss functions and cost minimization.",
      "Optimization Algorithms & Hyper-parameters.",
      "Underfitting vs Overfitting & Regularization.",
    ],
    "Neural Network Applications": [
      "Convolutional Neural Networks.",
      "Filters, kernels, strides, and padding.",
      "Image Classification and Segmentation.",
      "Object Detection.",
      "Recurrent Neural Networks.",
      "Time Series Forecasting.",
    ],
    "Image/ Text/ Audio Processing": [
      "Text Cleaning, Vectorization and Representation.",
      "Sentiment Analysis, Summarization, Topic Modeling.",
      "Chatbot & Virtual Assistants.",
      "Image Captioning.",
      "Audio pre-processing and feature extraction.",
      "Speech Emotion Recognition.",
      "Speech-to-Text Conversion.",
    ],
    "Real-World Impact & Capstone Journey": [
      "Explore domain-specific applications in business intelligence, digital ecosystems, healthcare, etc.",
      "Work on an end-to-end capstone project simulating an industry problem.",
      "Build a project portfolio showcasing your data science capabilities.",
    ],
  },
};
